import React from "react";
import App from "./app";

export default function Root(props) {
  return <App name={props.name} footerTopData={props.footerTopData} loginKey={props.loginKey}/>;
}
